import { CalendarDays, Users, UserRound, Wallet } from 'lucide-react';

// THE destination list — one copy, two shells.
//
// It was declared inside DentistLayout.jsx while the sidebar was the only
// navigation this app had. The mobile shell (src/components/mobile/MobileShell)
// renders the SAME three destinations in a bottom bar, and two hand-kept lists
// is exactly how a bar and a rail drift apart. Hoisted here so neither can
// declare its own; tests/routing.test.js asserts both import it.
//
// `labelKey`, not `label`: navigation is chrome that follows the UI language,
// and this list is module-level so it cannot call a hook itself.
//
// FOUR ENTRIES, because four screens exist. نسخه and the patient workspace
// are reached FROM a patient, not from a destination; the tooth chart, treatment
// plan, lab and recalls have no entry because they have no screen (CORE.md §8 —
// every dental module is roadmap, and a nav entry for an unbuilt screen is a
// lie). DESIGN-CONCEPT-MOBILE §3.1 states the same rule for the bottom bar:
// "Destinations are added here only when they have a mobile-designed screen."
//
// `Icon` is a component, not a rendered node: the rail draws it at 20px and the
// bottom bar at 22px, which a shared element could not do.
export const NAV_ITEMS = [
  {
    id: 'today',
    labelKey: 'nav.items.today',
    Icon: CalendarDays,
  },
  {
    id: 'patients',
    labelKey: 'nav.items.patients',
    Icon: Users,
  },
  {
    id: 'credits',
    labelKey: 'nav.items.credits',
    Icon: Wallet,
  },
  {
    id: 'profile',
    labelKey: 'nav.items.profile',
    Icon: UserRound,
  },
];

// Which destination is lit for a path. `/` is امروز; anything under a nav id's
// own prefix is that entry; a patient record and نسخه are reached FROM the
// register, so they keep بیماران lit rather than lighting nothing.
//
// It lives beside the list for the same reason the list moved here: the rail
// and the bottom bar have to agree about what is current, and they did not
// share a definition of "current" before.
export function activeNavFor(pathname) {
  if (pathname === '/' || pathname.startsWith('/today')) return 'today';
  if (pathname.startsWith('/patients') || pathname.startsWith('/prescription')) return 'patients';
  if (pathname.startsWith('/credits')) return 'credits';
  if (pathname.startsWith('/profile')) return 'profile';
  return null;
}

/**
 * The paths that are TOP-LEVEL mobile destinations — the only ones the bottom
 * bar renders on (DESIGN-CONCEPT-MOBILE §3.1: "flows, records and the Visit
 * workspace are full-screen; the page's own back affordance returns").
 *
 * `/patients/:id/:tab?` and `/prescription/:patientId` are deliberately absent:
 * they are drilled into, and their `MobileHeader` carries the way back.
 *
 * Exactly one entry per NAV_ITEMS id, which tests/routing.test.js pins — a
 * destination in the bar with no path here (or the reverse) is a bar that lights
 * nothing, or a screen the bar cannot reach.
 */
export const BOTTOM_NAV_PATHS = ['/', '/patients', '/credits', '/profile'];

/**
 * Is this path one of the three top-level destinations?
 *
 * The trailing slash is stripped first, and that is not tidiness. React Router
 * matches `/patients/` against `<Route path="/patients">` and renders the
 * register, but `useLocation().pathname` hands back the URL VERBATIM — so an
 * exact `includes` answered false for a screen that was on the display.
 * `activeNavFor` (which uses `startsWith`) said "patients" while this said "not
 * a destination", and the bar was therefore not rendered at all: on mobile
 * there is no rail to fall back on and a top-level screen carries no back
 * affordance, so a trailing slash — one pasted link, one hand-typed URL — left
 * the dentist on بیماران with no way to reach امروز or پروفایل again.
 *
 * `/` must survive the strip, so the empty string maps back to it.
 */
export const isTopLevelPath = (pathname) => {
  const normalized = String(pathname || '/').replace(/\/+$/, '') || '/';
  return BOTTOM_NAV_PATHS.includes(normalized);
};

export default NAV_ITEMS;
